import * as React from "react";
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.559}
      d="M21.5 27.25v4.375m-13.125 8.75h26.25A4.375 4.375 0 0 0 39 36V22.875a4.375 4.375 0 0 0-4.375-4.375H8.375A4.375 4.375 0 0 0 4 22.875V36a4.375 4.375 0 0 0 4.375 4.375ZM30.25 18.5V9.75a8.75 8.75 0 1 0-17.5 0v8.75h17.5Z"
    />
  </svg>
);
export default SvgComponent;
